module.exports = require("qtip");


//////////////////
// WEBPACK FOOTER
// external "qtip"
// module id = 27
// module chunks = 0


// WEBPACK FOOTER //
// webpack:/external "qtip"